import { CommentsApiResponse } from './useTicketComments.interface';

import { sendDatadogRumError } from 'utils/analytics/datadogRum';
import zendeskGateway from 'services/help-center/zendeskBackendGateway';

export default async function fetchTicketComments(ticketId: number, cursor?: string): Promise<CommentsApiResponse> {
    try {
        const params = new URLSearchParams({
            'page[size]': '20',
            include: 'users',
            sort: '-created_at',
        });

        if (cursor) {
            params.append('page[after]', cursor);
        }

        const url = `/tickets/${ticketId}/comments?${params.toString()}`;
        const response = await zendeskGateway.get<CommentsApiResponse>(url);

        const filteredComments = {
            ...response?.data,
            comments: (response?.data?.comments ?? []).filter((comment) => comment.public),
        };

        return filteredComments;
    } catch (error) {
        sendDatadogRumError('fetchTicketComments', error, { source: 'fetchTicketComments', ticketId, cursor });
        throw new Error('Failed to fetch ticket comments. Please try again later.');
    }
}
